/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Alerts_SaveInputs */

const es_billing_alerts_save = /** @type {(inputs: Billing_Alerts_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar alerta`)
};

const en_billing_alerts_save = /** @type {(inputs: Billing_Alerts_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save alert`)
};

/**
* | output |
* | --- |
* | "Save alert" |
*
* @param {Billing_Alerts_SaveInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const billing_alerts_save = /** @type {((inputs?: Billing_Alerts_SaveInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Alerts_SaveInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_billing_alerts_save(inputs)
	return en_billing_alerts_save(inputs)
});
export { billing_alerts_save as "billing.alerts.save" }